<div class="container">
  <section class="main" role="banner">
    <div class="landing-section center">
      <div class="flex-column">
        <div class="spanning-content">
          <h3>Have some uncertainties about Traccio?</h3>
        </div>
        <p>You might find some answers below! 🙌</p>
      </div>
      <div class="spacer"></div>
      <img src="https://res.cloudinary.com/djxztokzp/image/upload/v1607804534/Traccio_Assets/faq_graphic_u7hmdb.svg" alt="" class="hero-img" role="presentation">
    </div>
  </section>

  <div class="sticky-header-bg"></div>

  <section class="questions" role="main">
    <div class="landing-section alt" style="max-width: 1000px;">
      <app-faq [rootUrl]="'/faq'" [tag]="'ANTICIPATED 📍'"></app-faq>
      <nav class="faq">
        <p class="heading">On this page</p>
        <ul class="flex-column">
          <li *ngFor="let section of faqSections;">
            <a href="/faq#{{ section.id }}">{{ section.title }}</a>
          </li>
        </ul>
      </nav>
    </div>
  </section>

  <section class="call-to-action">
    <div class="landing-section col">
      <h3>Have more questions that weren't answered above? 📝</h3>
      <p>Feel free to reach out at <a href="mailto:support@traccio.app">support@traccio.app</a>!</p>
    </div>
  </section>

  <scroll-button *ngIf="(rs.tabletSize$ | async)"></scroll-button>
</div>
